// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .animation-container {
    background: #1e59ab;
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: hidden;
    }

    .shape1 {
    position: absolute;
    top: 42%;
    left: 70%;
    width: 25rem;
    height: 25rem;
    background: blue;
    border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;
    filter: blur(6rem);
    animation: shape1 20s infinite;
    }

    @keyframes shape1 {
    0% {
        transform: translate(0, 0);
        border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;
    }
    25% {
        transform: translate(-55%, -10%);
        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;
        height: 50rem;
        width: 80rem;
    }
    50% {
        transform: translate(-90%, -10%);
        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;
    }
    75% {
        transform: translate(-30%, -10%);
        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;
        height: 30rem;
        width: 45rem;
    }
    100% {
        transform: translate(0%, 0%);
        border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;
    }
    }

    .shape2 {
    position: absolute;
    top: 33%;
    left: 40%;
    width: 35rem;
    height: 25rem;
    background: lightblue;
    border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;
    filter: blur(12rem);
    animation: shape2 35s infinite;
    }

    @keyframes shape2 {
    0% {
        transform: translate(0, 0);
        border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;
    }
    25% {
        transform: translate(-55%, -55%);
        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;
        height: 50rem;
        width: 50rem;
    }
    50% {
        transform: translate(-70%, -70%);
        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;
    }
    75% {
        transform: translate(-30%, -30%);
        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;
    }
    100% {
        transform: translate(0%, 0%);
        border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;
    }
    }

    .shape3 {
    position: absolute;
    top: 20%;
    left: 80%;
    width: 25rem;
    height: 25rem;
    background: lightblue;
    border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;
    filter: blur(14rem);
    animation: shape3 35s infinite;
    }

    @keyframes shape3 {
    0% {
        transform: translate(0, 0);
        border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;
    }
    25% {
        transform: translate(-125%, -25%);
        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;
        height: 50rem;
        width: 50rem;
    }
    50% {
        transform: translate(-90%, -35%);
        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;
    }
    75% {
        transform: translate(-30%, -40%);
        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;
    }
    100% {
        transform: translate(0%, 0%);
        border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;
    }
    }

    .shape4 {
    position: absolute;
    top: 42%;
    left: 70%;
    width: 25rem;
    height: 25rem;
    background: rgb(192, 217, 255);
    border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;
    filter: blur(5rem);
      animation: shape1 20s infinite;
    }

    .shape5 {
    position: absolute;
    top: 33%;
    left: 40%;
    width: 35rem;
    height: 25rem;
    background: rgb(235, 255, 224);
    border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;
    filter: blur(5rem);
      animation: shape2 15s infinite;
    }

    .shape6 {
    position: absolute;
    top: 20%;
    left: 80%;
    width: 25rem;
    height: 25rem;
    background: lightblue;
    border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;
    filter: blur(5rem);
      animation: shape3 30s infinite;
    }

    .shape1, .shape2, .shape3, .shape4, .shape5, .shape6 {
        /*position: absolute;
        filter: blur(4rem);  Blur değerini düşürerek performansı artırıyoruz */
        will-change: transform, border-radius; /* Performans iyileştirmesi için */
    }`, "",{"version":3,"sources":["webpack://./src/layouts/authentication/two-factor/AnimationStyles.css"],"names":[],"mappings":"IAAI;IACA,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gDAAgD;IAChD,kBAAkB;IAClB,8BAA8B;IAC9B;;IAEA;IACA;QACI,0BAA0B;QAC1B,gDAAgD;IACpD;IACA;QACI,gCAAgC;QAChC,gDAAgD;QAChD,aAAa;QACb,YAAY;IAChB;IACA;QACI,gCAAgC;QAChC,+CAA+C;IACnD;IACA;QACI,gCAAgC;QAChC,gDAAgD;QAChD,aAAa;QACb,YAAY;IAChB;IACA;QACI,4BAA4B;QAC5B,gDAAgD;IACpD;IACA;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,+CAA+C;IAC/C,mBAAmB;IACnB,8BAA8B;IAC9B;;IAEA;IACA;QACI,0BAA0B;QAC1B,+CAA+C;IACnD;IACA;QACI,gCAAgC;QAChC,gDAAgD;QAChD,aAAa;QACb,YAAY;IAChB;IACA;QACI,gCAAgC;QAChC,+CAA+C;IACnD;IACA;QACI,gCAAgC;QAChC,gDAAgD;IACpD;IACA;QACI,4BAA4B;QAC5B,+CAA+C;IACnD;IACA;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,gDAAgD;IAChD,mBAAmB;IACnB,8BAA8B;IAC9B;;IAEA;IACA;QACI,0BAA0B;QAC1B,gDAAgD;IACpD;IACA;QACI,iCAAiC;QACjC,gDAAgD;QAChD,aAAa;QACb,YAAY;IAChB;IACA;QACI,gCAAgC;QAChC,+CAA+C;IACnD;IACA;QACI,gCAAgC;QAChC,gDAAgD;IACpD;IACA;QACI,4BAA4B;QAC5B,gDAAgD;IACpD;IACA;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,gDAAgD;IAChD,kBAAkB;MAChB,8BAA8B;IAChC;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,+CAA+C;IAC/C,kBAAkB;MAChB,8BAA8B;IAChC;;IAEA;IACA,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,gDAAgD;IAChD,kBAAkB;MAChB,8BAA8B;IAChC;;IAEA;QACI;8EACsE;QACtE,qCAAqC,EAAE,kCAAkC;IAC7E","sourcesContent":["    .animation-container {\n    background: #1e59ab;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    }\n\n    .shape1 {\n    position: absolute;\n    top: 42%;\n    left: 70%;\n    width: 25rem;\n    height: 25rem;\n    background: blue;\n    border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;\n    filter: blur(6rem);\n    animation: shape1 20s infinite;\n    }\n\n    @keyframes shape1 {\n    0% {\n        transform: translate(0, 0);\n        border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;\n    }\n    25% {\n        transform: translate(-55%, -10%);\n        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;\n        height: 50rem;\n        width: 80rem;\n    }\n    50% {\n        transform: translate(-90%, -10%);\n        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;\n    }\n    75% {\n        transform: translate(-30%, -10%);\n        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;\n        height: 30rem;\n        width: 45rem;\n    }\n    100% {\n        transform: translate(0%, 0%);\n        border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;\n    }\n    }\n\n    .shape2 {\n    position: absolute;\n    top: 33%;\n    left: 40%;\n    width: 35rem;\n    height: 25rem;\n    background: lightblue;\n    border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;\n    filter: blur(12rem);\n    animation: shape2 35s infinite;\n    }\n\n    @keyframes shape2 {\n    0% {\n        transform: translate(0, 0);\n        border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;\n    }\n    25% {\n        transform: translate(-55%, -55%);\n        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;\n        height: 50rem;\n        width: 50rem;\n    }\n    50% {\n        transform: translate(-70%, -70%);\n        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;\n    }\n    75% {\n        transform: translate(-30%, -30%);\n        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;\n    }\n    100% {\n        transform: translate(0%, 0%);\n        border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;\n    }\n    }\n\n    .shape3 {\n    position: absolute;\n    top: 20%;\n    left: 80%;\n    width: 25rem;\n    height: 25rem;\n    background: lightblue;\n    border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;\n    filter: blur(14rem);\n    animation: shape3 35s infinite;\n    }\n\n    @keyframes shape3 {\n    0% {\n        transform: translate(0, 0);\n        border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;\n    }\n    25% {\n        transform: translate(-125%, -25%);\n        border-radius: 28% 72% 81% 19% / 78% 25% 75% 22%;\n        height: 50rem;\n        width: 50rem;\n    }\n    50% {\n        transform: translate(-90%, -35%);\n        border-radius: 60% 40% 0% 100% / 1% 74% 26% 99%;\n    }\n    75% {\n        transform: translate(-30%, -40%);\n        border-radius: 0% 100% 100% 0% / 0% 100% 100% 0%;\n    }\n    100% {\n        transform: translate(0%, 0%);\n        border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;\n    }\n    }\n\n    .shape4 {\n    position: absolute;\n    top: 42%;\n    left: 70%;\n    width: 25rem;\n    height: 25rem;\n    background: rgb(192, 217, 255);\n    border-radius: 24% 76% 77% 23% / 30% 30% 70% 70%;\n    filter: blur(5rem);\n      animation: shape1 20s infinite;\n    }\n\n    .shape5 {\n    position: absolute;\n    top: 33%;\n    left: 40%;\n    width: 35rem;\n    height: 25rem;\n    background: rgb(235, 255, 224);\n    border-radius: 73% 27% 77% 23% / 53% 4% 96% 47%;\n    filter: blur(5rem);\n      animation: shape2 15s infinite;\n    }\n\n    .shape6 {\n    position: absolute;\n    top: 20%;\n    left: 80%;\n    width: 25rem;\n    height: 25rem;\n    background: lightblue;\n    border-radius: 70% 30% 80% 20% / 42% 25% 75% 58%;\n    filter: blur(5rem);\n      animation: shape3 30s infinite;\n    }\n\n    .shape1, .shape2, .shape3, .shape4, .shape5, .shape6 {\n        /*position: absolute;\n        filter: blur(4rem);  Blur değerini düşürerek performansı artırıyoruz */\n        will-change: transform, border-radius; /* Performans iyileştirmesi için */\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
